import { render, staticRenderFns } from "./ExpandTransition.vue?vue&type=template&id=b0ab5d8c&scoped=true"
import script from "./ExpandTransition.vue?vue&type=script&lang=js"
export * from "./ExpandTransition.vue?vue&type=script&lang=js"
import style0 from "./ExpandTransition.vue?vue&type=style&index=0&id=b0ab5d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ab5d8c",
  null
  
)

export default component.exports